import '../scss/styles.scss';
import 'bootstrap';
import app from './app.js';

app();
